import { useEffect, useMemo, useState } from "react"
import { useSearchspringSearchContext } from "@app/scripts/providers/searchspring"
import { SearchspringSearchResult } from "@app/types"
import { useSearchspringOption } from "./use-searchspring-option"

type SearchspringItems = Array<SearchspringSearchResult | string>

export function useSearchspringResults() {
  const { response } = useSearchspringSearchContext()

  const page = useSearchspringOption("page", {
    defaultValue: 1,
  })

  const currentResults = useMemo(() => {
    if (!response) return []

    const results: SearchspringItems = response.results

    // splice in any inline content banners
    response?.merchandising?.content?.inline?.forEach((banner) => {
      const isCorrectPage =
        banner.config.position.index >= response?.pagination?.begin &&
        banner.config.position.index < response?.pagination?.end

      const relativeIndex =
        banner.config.position.index - (response?.pagination?.begin || 0) + 1
      if (isCorrectPage) {
        results.splice(relativeIndex, 0, banner.value)
      }
    })
    return results
  }, [response])

  const [resultPages, setResultPages] = useState(
    new Map<number, SearchspringItems>()
  )

  useEffect(() => {
    if (!response) return
    setResultPages((prev) => {
      const next = new Map(prev)
      const page = response.pagination.currentPage
      next.set(page, currentResults)
      return next
    })
  }, [currentResults])

  const results = useMemo(() => {
    return Array.from(resultPages.values()).reduce((results, pageResults) => {
      return [...results, ...pageResults]
    }, [] as SearchspringItems)
  }, [resultPages])

  useEffect(() => {}, [page, currentResults])

  return results
}
